import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidesheet px-4 py-4" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "zamg-text-headline" }
const _hoisted_4 = { class: "slider-with-header mt-4" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: ".zamg-text-small-continous" }
const _hoisted_7 = { class: "zamg-text-label zamg-text-small-continous" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_text_field_with_date_picker = _resolveComponent("text-field-with-date-picker")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_ctx.localShow)
    ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
        key: 0,
        modelValue: _ctx.localShow,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.localShow) = $event)),
        color: "white",
        absolute: "",
        temporary: "",
        persistent: "",
        scrim: false,
        location: "left",
        width: "22vw",
        class: "filter-drawer elevation-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('side_sheet.header')), 1),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                "data-testid": "filter-drawer-close",
                variant: "text",
                onClick: _withModifiers(_ctx.toggleDrawer, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode(_component_v_divider, { opacity: "25" }),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.localFilters.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFilters.id) = $event)),
              class: "mt-4",
              label: _ctx.t('station_table.table.id'),
              hint: _ctx.t('hints.text_can_be_separated_by_comma'),
              "data-testid": "filter-id",
              variant: "filled",
              "persistent-hint": "",
              density: "compact",
              onInput: _cache[1] || (_cache[1] = (event) => _ctx.putFilterDebounced({ id: _ctx.cleanString(event.target.value) }))
            }, null, 8, ["modelValue", "label", "hint"]),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.localFilters.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFilters.name) = $event)),
              class: "mt-4",
              label: _ctx.t('station_table.table.name'),
              hint: _ctx.t('hints.text_can_be_separated_by_comma'),
              "data-testid": "filter-name",
              variant: "filled",
              "persistent-hint": "",
              density: "compact",
              onInput: _cache[3] || (_cache[3] = (event) => _ctx.putFilterDebounced({ name: _ctx.cleanString(event.target.value) }))
            }, null, 8, ["modelValue", "label", "hint"]),
            _createVNode(_component_v_select, {
              modelValue: _ctx.localFilters.states,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFilters.states) = $event)),
                _cache[5] || (_cache[5] = (value) => _ctx.putFilterDebounced({ states: _ctx.cleanStates(value) }))
              ],
              class: "mt-4",
              label: _ctx.t('station_table.table.state'),
              items: _ctx.localizedStates,
              "item-title": "label",
              "item-value": "value",
              "data-testid": "filter-state",
              multiple: "",
              variant: "filled",
              "hide-details": "",
              density: "compact"
            }, null, 8, ["modelValue", "label", "items"]),
            _createVNode(_component_text_field_with_date_picker, {
              value: _ctx.localFilters.startDate,
              class: "mt-4",
              label: _ctx.t('start_date'),
              "show-hint": false,
              testid: 'filter-drawer-start-date',
              "allowed-date-range": [
          _ctx.datasetStore.metadata?.startDate,
          _ctx.datasetStore.metadata?.endDate,
        ],
              "selected-date-is-start-date": true,
              "reference-date": _ctx.localFilters.endDate,
              "text-field-props": { filled: true, density: 'compact' },
              onDateSelected: _cache[6] || (_cache[6] = (value) => _ctx.putFilterDebounced({ startDate: _ctx.cleanDate(value) }))
            }, null, 8, ["value", "label", "allowed-date-range", "reference-date"]),
            _createVNode(_component_text_field_with_date_picker, {
              value: _ctx.localFilters.endDate,
              class: "mt-4",
              label: _ctx.t('end_date'),
              "show-hint": false,
              testid: 'filter-drawer-end-date',
              "allowed-date-range": [
          _ctx.datasetStore.metadata?.startDate,
          _ctx.datasetStore.metadata?.endDate,
        ],
              "selected-date-is-start-date": false,
              "reference-date": _ctx.localFilters.startDate,
              "text-field-props": { filled: true, density: 'compact' },
              onDateSelected: _cache[7] || (_cache[7] = (value) => _ctx.putFilterDebounced({ endDate: _ctx.cleanDate(value) }))
            }, null, 8, ["value", "label", "allowed-date-range", "reference-date"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('side_sheet.altitudeSliderLabel')), 1),
                _createVNode(_component_v_spacer),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.altitudeFormatted), 1)
              ]),
              _createVNode(_component_v_range_slider, {
                modelValue: _ctx.localFilters.altitude,
                "onUpdate:modelValue": [
                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localFilters.altitude) = $event)),
                  _cache[9] || (_cache[9] = (value) => _ctx.putFilterDebounced({ altitude: _ctx.cleanAltitude(value) }))
                ],
                max: _ctx.defaultAltitude?.[1],
                min: _ctx.defaultAltitude?.[0],
                "data-testid": "filter-station-altitude",
                step: "50",
                "hide-details": "",
                density: "compact",
                color: "primary"
              }, null, 8, ["modelValue", "max", "min"])
            ]),
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localFilters.onlyWithSunshine,
              "onUpdate:modelValue": [
                _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localFilters.onlyWithSunshine) = $event)),
                _cache[11] || (_cache[11] = (value) => _ctx.putFilterDebounced({ onlyWithSunshine: _ctx.cleanBoolean(value) }))
              ],
              class: "mt-4",
              "hide-details": "",
              "data-testid": "filter-station-only-with-sunshine",
              label: _ctx.t('station_table.only_stations_with') + ' ' + _ctx.t('station_table.table.hasSunshine'),
              density: "compact"
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localFilters.onlyWithGlobalRadiation,
              "onUpdate:modelValue": [
                _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localFilters.onlyWithGlobalRadiation) = $event)),
                _cache[13] || (_cache[13] = (value) => _ctx.putFilterDebounced({ onlyWithGlobalRadiation: _ctx.cleanBoolean(value) }))
              ],
              class: "mt-4",
              "hide-details": "",
              "data-testid": "filter-station-only-with-global-radiation",
              label: _ctx.t('station_table.only_stations_with') + ' ' + _ctx.t('station_table.table.hasGlobalRadiation'),
              density: "compact"
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localFilters.onlyCurrent,
              "onUpdate:modelValue": [
                _cache[14] || (_cache[14] = ($event: any) => ((_ctx.localFilters.onlyCurrent) = $event)),
                _cache[15] || (_cache[15] = (value) => _ctx.putFilterDebounced({ onlyCurrent: _ctx.cleanBoolean(value) }))
              ],
              class: "mt-4",
              "hide-details": "",
              "data-testid": "filter-station-only-current",
              label: _ctx.t('station_table.only_current_stations'),
              density: "compact"
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}